// extracted by mini-css-extract-plugin
export default {"text_gray":"AddRequest_text_gray__TMg6z","show_less":"AddRequest_show_less__Ak3N9","btn_primary":"AddRequest_btn_primary__PcElo"};